import React, { Component } from 'react';
import { crudActions } from "@sm/services/crudActions";
import Form from "@sm/core/Form";
import { DATA_TYPES } from "@modules/data/ManualInput";

class TopUpByRequestComponent extends Component {
  componentDidMount() {
    const { companiesPsps, controls, getOptionsFromState } = this.props;
    if (companiesPsps && controls) {
      this.setState({
        providers: companiesPsps[controls.company],
        getOptionsFromParentState: getOptionsFromState,
      });
    }
  };

  componentDidUpdate(prevProps) {
    const { companiesPsps, savedData, form } = this.props;

    if (savedData && companiesPsps.length !== prevProps.companiesPsps.length) {
      this.setState({ providers: companiesPsps[savedData.company] });
    }

    if (form?.providerId && form?.providerId !== this.prevProviderId) {
      this.updateField(DATA_TYPES.TOP_UP_PAYOUT_WALLET_BY_REQUEST, [this.getTopUpPayoutWalletByRequestFields()]);
      this.prevProviderId = form.providerId;
    }
  }

  onChangeFilter = () => {
    const { controls } = this.props;

    const isFormValid = controls.isFormValid();
    this.onChangeValidationUpdate(controls, isFormValid);

    if (isFormValid) {
      const { merchant, currency, id } = controls;
      const url = `v1/payout/top-ups/requested?clientIds=${ merchant }&currency=${ currency }${ id ? `&id=${id}` : '' }`;

      crudActions.get(url)
        .then((response) => {
          if (response.length) {
            const newState = this.populateTopUpPayoutWalletByRequestForm(response, controls);
            Object.assign(newState, {
              showSecondPanel: true,
              loadingDataInput: false,
              lockButton: false,
            });
            this.updateState(newState);
          } else {
            this.errorUpdate("No active top-up requests found. All existing requests are already approved or cancelled.");
          }
        })
        .catch((err) => {
          this.errorUpdate(err ? err.message : "");
        });
    }
  };

  populateTopUpPayoutWalletByRequestForm = (response, controls) => {
    const TOP_UP_PAYOUT_WALLET_BY_REQUEST = [];
    const stateForUpdate = {};

    response.forEach((elem, id) => TOP_UP_PAYOUT_WALLET_BY_REQUEST.push(this.getTopUpPayoutWalletByRequestFields(id)));
    const topUpPayoutWalletByRequestForm = [];
    response.forEach(topUp => {
      topUpPayoutWalletByRequestForm.push(this.getTopUpPayoutWalletByRequestForm(topUp, controls));
    });

    this.updateField(DATA_TYPES.TOP_UP_PAYOUT_WALLET_BY_REQUEST, TOP_UP_PAYOUT_WALLET_BY_REQUEST);
    Object.assign(stateForUpdate, {
      topUpPayoutWalletByRequestForm: topUpPayoutWalletByRequestForm
    });
    return stateForUpdate;
  };

  getTopUpPayoutWalletByRequestForm = (data, controls) => {
    const merchants = this.state.getOptionsFromParentState("companiesClients")[controls.company];
    const merchant =  data.merchant ? merchants.find(client => client.value === data.merchant.toString()) : '';
    return new Form(
      {
        id: data.id,
        currency: controls.currency || "",
        merchant: data.merchant || "",
        merchantName: data.merchant ? merchant.label : '',
        date: data.date || "date",
        totalAvailableBalance: data.currencyAb,
        payoutFee: data?.payoutFee || 0,
        topUpAmount: data.topUpAmount.toString(),
        topUpFee: data.payoutFee ? parseFloat(data.topUpAmount * (data.payoutFee / 100)).toFixed(2) : 0,
        method: data.method.replace('_', ' '),
        originalMethod: data.method,
        midId: "",
        providerId: "",
        availableBalance: 0
      },
      [
        {
          name: "currency",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "totalAvailableBalance",
          type: "isNumber",
          rules: {
            min: 1,
            required: true,
          },
        },
        {
          name: "topUpAmount",
          type: "isString",
          rules: {
            min: 1,
            required: true,
          },
        },
        {
          name: "midId",
          type: "isNumber",
          rules: {
            required: true,
          },
        },
        {
          name: "providerId",
          type: "isNumber",
          rules: {
            required: true,
          },
        },
        {
          name: "availableBalance",
          type: "isNumber",
          rules: {
            min: 1,
            required: true,
          },
        },
      ]
    );
  };

  getMids = (id) => {
    const { form, filterMids } = this.props;

    const current = form?.[id];
    if (!current?.providerId) return [];

    const { providerId, merchant, originalMethod } = current;

    const occupiedMids = form
      .filter((item, index) => index !== id && item.providerId === providerId)
      .map((item) => item.midId);

    return filterMids(providerId.toString(), merchant, originalMethod)
      .filter((mid) => !occupiedMids.includes(mid.value))
      .map((mid) => ({
        ...mid,
        value: String(mid.value),
      }));
  };

  getTopUpPayoutWalletByRequestFields = (id) => {

    return [
      {
        name: "merchantName",
        label: "Merchant",
        disabled: true,
        fieldType: "input",
        flexGrow: 4,
      }, {
        name: "date",
        label: "Date",
        disabled: true,
        fieldType: "input",
        // formatValue: true,
        flexGrow: 4,
      }, {
        name: "totalAvailableBalance",
        label: "Available Balance",
        disabled: true,
        fieldType: "input",
        formatValue: true,
        flexGrow: 4,
        rightAlign: true,
      }, {
        name: "method",
        label: "Method",
        disabled: true,
        fieldType: "input",
        formatValue: false,
        flexGrow: 4,
        rightAlign: true,
      }, {
        name: "providerId",
        label: "Provider",
        fieldType: "select",
        getOptions: () => this.getOptionsFromState("providers"),
        items: "providers",
        flexGrow: 6,
      }, {
        name: "midId",
        label: "MID",
        fieldType: "select",
        getOptions: () => this.getMids(id),
        items: "mids",
        flexGrow: 6,
      }, {
        name: "availableBalance",
        label: "Balance",
        disabled: true,
        fieldType: "input",
        formatValue: true,
        flexGrow: 4,
        rightAlign: true,
      }, {
        name: "topUpAmount",
        label: "Top Up Amount",
        fieldType: "isString",
        flexGrow: 4,
        rightAlign: true,
      },
      {
        name: "topUpFee",
        label: "Fee",
        fieldType: "isString",
        flexGrow: 3,
        disabled: true
      },
      {
        fieldType: "button",
        buttonLabel: "Cancel",
        className: "btn-secondary",
        buttonAction: () => this.cancelTopUpRequest(id)
      }, {
        fieldType: "button",
        buttonLabel: "Approve",
        buttonAction: () => this.approveTopUpRequest(id)
      }
    ];
  };

  decreaseForm = (form) => {
    const TOP_UP_PAYOUT_WALLET_BY_REQUEST = [];
    form.forEach((elem, index) => TOP_UP_PAYOUT_WALLET_BY_REQUEST.push(this.getTopUpPayoutWalletByRequestFields(index)));
    this.updateField(DATA_TYPES.TOP_UP_PAYOUT_WALLET_BY_REQUEST, TOP_UP_PAYOUT_WALLET_BY_REQUEST);
    this.updateState({
      topUpPayoutWalletByRequestForm: form
    });
  };

  approveTopUpRequest = (id) => {
    const { form } = this.props;
    const formRow = form[id];
    const isFormValid = formRow.isFormValid();

    this.saveValidationUpdate(form, isFormValid, isFormValid);

    if (isFormValid) {
      if (parseFloat(formRow.topUpAmount) <= parseFloat(formRow.availableBalance)) {
        const params = {
          id: formRow.id,
          midId: formRow.midId,
          payoutFee: formRow.payoutFee,
          topUpAmount: formRow.topUpAmount
        };
        const query = new URLSearchParams(params).toString();
        crudActions.post(`v1/payout/top-ups/approve?${ query }`)
          .then(() => {
            form.splice(id, 1);
            this.afterSuccessSave("Top Up approved.", form.length > 0);
            this.decreaseForm(form, id);
          }).catch((err) => {
            this.errorUpdate(err ? err.message : '');
          });
      }  else {
        this.errorUpdate('MID balance is not enough!');
      }
    }
  };

  cancelTopUpRequest = (id) => {
    const { form } = this.props;
    const formRow = form[id];
    crudActions.put(`v1/payout/top-ups/decline?id=${ formRow.id }`)
      .then(() => {
        form.splice(id, 1);
        this.afterSuccessSave("Top Up declined.", form.length > 0);
        this.decreaseForm(form, id);
      }).catch((err) => {
        this.errorUpdate(err ? err.message : '');
      });
  };

  getOptionsFromState = (optionsName) => {
    return this.state[optionsName];
  };

  updateField = (name, value) => {
    this.props.updateField(name, value);
  };

  updateState = (stateForUpdate) => {
    this.props.updateState(stateForUpdate);
  };

  onChangeValidationUpdate = (controls, isFormValid) => {
    this.props.updateStateAfterOnChangeValidation(controls, isFormValid);
  };
  
  saveValidationUpdate = (form, isFormValid, allValid) => {
    this.props.updateStateAfterOnSaveValidation(form, isFormValid, allValid);
  };

  afterSuccessSave = (message, dataPresent) => {
    this.props.updateStateAfterSuccessSave(message, dataPresent);
  };

  errorUpdate = (message) => {
    this.props.showErrorAlert(message);
  };

  render() {
    return <></>;
  };
}

export default TopUpByRequestComponent;